var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","small":"","color":_vm.item.is_omitted === true ? 'warning' : ''},on:{"click":_vm.updateItem}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("fa-times-circle")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }